/**
 * The portal's language set — identical to the app's (`SupportedLanguage` in
 * patient-app LocalizationProvider) and to the backend's `languageSchema`, so
 * a choice made on one surface is valid on the other.
 */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'it', 'ar'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

/** Endonyms for the picker — a patient looks for their own language in its own script. */
export const LANGUAGE_ENDONYMS: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  it: 'Italiano',
  ar: 'العربية',
};

const LOCALES: Record<SupportedLanguage, string> = {
  en: 'en-US',
  es: 'es-ES',
  it: 'it-IT',
  // Western digits, matching the app: chosen for clinical/banking legibility.
  ar: 'ar-u-nu-latn',
};

export function localeForLanguage(language: SupportedLanguage): string {
  return LOCALES[language];
}

export function normalizeLanguage(input?: unknown): SupportedLanguage | null {
  if (typeof input !== 'string') return null;
  const base = input.trim().toLowerCase().split(/[-_]/)[0];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base) ? (base as SupportedLanguage) : null;
}
